import { render, staticRenderFns } from "./CoutParProduit.vue?vue&type=template&id=80b8a1ec&scoped=true"
import script from "./CoutParProduit.vue?vue&type=script&lang=js"
export * from "./CoutParProduit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b8a1ec",
  null
  
)

export default component.exports